module.exports = __webpack_public_path__ + "img/hand_sideleft_43.4cde9855.svg";